/* eslint-disable no-useless-escape */
export const pictureRegExp = '(https?:\/\/.*\.(?:png|jpg|jpeg|avif|webp))';
